import { QueryClient } from '@tanstack/react-query';
import { ApiError } from '@/core/api/errors';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      // Retrying a 4xx never helps; transient network/5xx errors get two more tries.
      retry: (count, error) => {
        const status = error instanceof ApiError ? error.status : null;
        if (status != null && status >= 400 && status < 500) return false;
        return count < 2;
      },
    },
  },
});
